import React from 'react';
import './FormDescription.css';

/**
 * FormDescription Component
 * Descriptive text/help text for forms
 * 
 * @param {string} text - Description text
 * @param {string} variant - Variant: 'default' | 'help' | 'error' (default: 'default')
 * @param {string} className - Additional CSS classes
 */
const FormDescription = ({
  text,
  variant = 'default',
  className = ''
}) => {
  const variantClass = `form-description-${variant}`;

  return (
    <p className={`form-description ${variantClass} ${className}`.trim()}>
      {text}
    </p>
  );
};

export default FormDescription;










